<template>
  <div>
    <v-card class="pt-3 pb-3 mb-3">
      <v-row>
        <v-card-title>
          <h2 class="text-xl">Total par site</h2>
        </v-card-title>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            class="ml-6 mr-6"
            v-model="search"
            append-icon="mdi-magnify"
            label="Recherche"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-data-table
            class="ml-6 mr-6"
            :items="items"
            :headers="headers"
            :search="search"
          >
            <template v-slot:item.revenue="{ item }">
              <span>{{ formatRevenue(item.revenue) }}</span>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import useAxios from "@/hooks/useAxios";
import debounce from "lodash/debounce";

export default {
  name: "utmContentSiteTotalsTable",
  components: {},

  data() {
    return {
      search: "",
      items: [],
      headers: [
        { text: "Site", value: "site_name" },
        { text: "Domain", value: "domain" },
        { text: "Revenue total", value: "revenue" },
        { text: "Devise", value: "unit_code" },
      ],
    };
  },

  setup() {
    const { axiosGet, isLoading } = useAxios();

    return {
      axiosGet,
      isLoading,
    };
  },

  methods: {
    debouncedUpdateData: debounce(async function () {
      await this.getData();
    }, 500),

    async getData() {
      const params = {
        date_start: this.dateRange[0],
        date_end: this.dateRange[1],
      };
      const response = await this.axiosGet(
        "/acquisition/utm-content/report/totals_by_site",
        params
      );
      this.items = response.data;
    },
    formatRevenue(revenue) {
      return Number(revenue).toFixed(2);
    },
  },
  async created() {},
  computed: {
    filtersApplied() {
      return this.$store.getters["common/getApplyFilters"];
    },
    dateRange() {
      return this.$store.getters["acquisition/getDates"];
    },
  },
  watch: {
    filtersApplied(val) {
      if (val) {
        this.debouncedUpdateData();
      }
    },
  },
};
</script>
